import { render } from "./App.vue?vue&type=template&id=0da1c78a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/norbert-weston/norbert-weston-1/apps/norbert-weston-flirter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__